(function () {
  function closeCartDrawerIfOtpExists() {
    const otpCard   = document.querySelector(".rsi-otp-card");
    const closeBtn  = document.querySelector(".cart-drawer__close-button");

    // Solo cerrar si EXISTEN LAS DOS cosas al mismo tiempo
    if (otpCard && closeBtn) {
      closeBtn.click();
    }
  }

  // Revisar una vez al cargar
  closeCartDrawerIfOtpExists();

  // Observar cambios en el DOM para detectar cuando aparezca el OTP
  const observer = new MutationObserver(closeCartDrawerIfOtpExists);

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
